function te(r) {
  let e;
  const t = `algolia-client-js-${r.key}`;
  function n() {
    return e === void 0 && (e = r.localStorage || window.localStorage), e;
  }
  function a() {
    return JSON.parse(n().getItem(t) || "{}");
  }
  function c(l) {
    n().setItem(t, JSON.stringify(l));
  }
  function g() {
    const l = r.timeToLive ? r.timeToLive * 1e3 : null, u = a(), f = Object.fromEntries(
      Object.entries(u).filter(([, v]) => v.timestamp !== void 0)
    );
    if (c(f), !l)
      return;
    const d = Object.fromEntries(
      Object.entries(f).filter(([, v]) => {
        const T = (/* @__PURE__ */ new Date()).getTime();
        return !(v.timestamp + l < T);
      })
    );
    c(d);
  }
  return {
    get(l, u, f = {
      miss: () => Promise.resolve()
    }) {
      return Promise.resolve().then(() => (g(), a()[JSON.stringify(l)])).then((d) => Promise.all([d ? d.value : u(), d !== void 0])).then(([d, v]) => Promise.all([d, v || f.miss(d)])).then(([d]) => d);
    },
    set(l, u) {
      return Promise.resolve().then(() => {
        const f = a();
        return f[JSON.stringify(l)] = {
          timestamp: (/* @__PURE__ */ new Date()).getTime(),
          value: u
        }, n().setItem(t, JSON.stringify(f)), u;
      });
    },
    delete(l) {
      return Promise.resolve().then(() => {
        const u = a();
        delete u[JSON.stringify(l)], n().setItem(t, JSON.stringify(u));
      });
    },
    clear() {
      return Promise.resolve().then(() => {
        n().removeItem(t);
      });
    }
  };
}
function H() {
  return {
    get(r, e, t = {
      miss: () => Promise.resolve()
    }) {
      return e().then((a) => Promise.all([a, t.miss(a)])).then(([a]) => a);
    },
    set(r, e) {
      return Promise.resolve(e);
    },
    delete(r) {
      return Promise.resolve();
    },
    clear() {
      return Promise.resolve();
    }
  };
}
function E(r) {
  const e = [...r.caches], t = e.shift();
  return t === void 0 ? H() : {
    get(n, a, c = {
      miss: () => Promise.resolve()
    }) {
      return t.get(n, a, c).catch(() => E({ caches: e }).get(n, a, c));
    },
    set(n, a) {
      return t.set(n, a).catch(() => E({ caches: e }).set(n, a));
    },
    delete(n) {
      return t.delete(n).catch(() => E({ caches: e }).delete(n));
    },
    clear() {
      return t.clear().catch(() => E({ caches: e }).clear());
    }
  };
}
function ne(r = { serializable: !0 }) {
  let e = {};
  return {
    get(t, n, a = {
      miss: () => Promise.resolve()
    }) {
      const c = JSON.stringify(t);
      if (c in e)
        return Promise.resolve(r.serializable ? JSON.parse(e[c]) : e[c]);
      const g = n();
      return g.then((l) => a.miss(l)).then(() => g);
    },
    set(t, n) {
      return e[JSON.stringify(t)] = r.serializable ? JSON.stringify(n) : n, Promise.resolve(n);
    },
    delete(t) {
      return delete e[JSON.stringify(t)], Promise.resolve();
    },
    clear() {
      return e = {}, Promise.resolve();
    }
  };
}
function M(r) {
  const e = {
    value: `Algolia for JavaScript (${r})`,
    add(t) {
      const n = `; ${t.segment}${t.version !== void 0 ? ` (${t.version})` : ""}`;
      return e.value.indexOf(n) === -1 && (e.value = `${e.value}${n}`), e;
    }
  };
  return e;
}
function ae(r, e, t = "WithinHeaders") {
  const n = {
    "x-algolia-api-key": e,
    "x-algolia-application-id": r
  };
  return {
    headers() {
      return t === "WithinHeaders" ? n : {};
    },
    queryParameters() {
      return t === "WithinQueryParameters" ? n : {};
    }
  };
}
function oe({ algoliaAgents: r, client: e, version: t }) {
  const n = M(t).add({
    segment: e,
    version: t
  });
  return r.forEach((a) => n.add(a)), n;
}
function ie() {
  return {
    debug(r, e) {
      return Promise.resolve();
    },
    info(r, e) {
      return Promise.resolve();
    },
    error(r, e) {
      return Promise.resolve();
    }
  };
}
var R = 120 * 1e3;
function D(r, e = "up") {
  const t = Date.now();
  function n() {
    return e === "up" || Date.now() - t > R;
  }
  function a() {
    return e === "timed out" && Date.now() - t <= R;
  }
  return { ...r, status: e, lastUpdate: t, isUp: n, isTimedOut: a };
}
var _ = class extends Error {
  name = "AlgoliaError";
  constructor(r, e) {
    super(r), e && (this.name = e);
  }
}, W = class extends _ {
  stackTrace;
  constructor(r, e, t) {
    super(r, t), this.stackTrace = e;
  }
}, G = class extends W {
  constructor(r) {
    super(
      "Unreachable hosts - your application id may be incorrect. If the error persists, please visit our help center https://alg.li/support-unreachable-hosts or reach out to the Algolia Support team: https://alg.li/support",
      r,
      "RetryError"
    );
  }
}, x = class extends W {
  status;
  constructor(r, e, t, n = "ApiError") {
    super(r, t, n), this.status = e;
  }
}, C = class extends _ {
  response;
  constructor(r, e) {
    super(r, "DeserializationError"), this.response = e;
  }
}, B = class extends x {
  error;
  constructor(r, e, t, n) {
    super(r, e, n, "DetailedApiError"), this.error = t;
  }
};
function se(r) {
  const e = r;
  for (let t = r.length - 1; t > 0; t--) {
    const n = Math.floor(Math.random() * (t + 1)), a = r[t];
    e[t] = r[n], e[n] = a;
  }
  return e;
}
function F(r, e, t) {
  const n = K(t);
  let a = `${r.protocol}://${r.url}${r.port ? `:${r.port}` : ""}/${e.charAt(0) === "/" ? e.substring(1) : e}`;
  return n.length && (a += `?${n}`), a;
}
function K(r) {
  return Object.keys(r).filter((e) => r[e] !== void 0).sort().map(
    (e) => `${e}=${encodeURIComponent(
      Object.prototype.toString.call(r[e]) === "[object Array]" ? r[e].join(",") : r[e]
    ).replace(/\+/g, "%20")}`
  ).join("&");
}
function Q(r, e) {
  if (r.method === "GET" || r.data === void 0 && e.data === void 0)
    return;
  const t = Array.isArray(r.data) ? r.data : { ...r.data, ...e.data };
  return JSON.stringify(t);
}
function X(r, e, t) {
  const n = {
    Accept: "application/json",
    ...r,
    ...e,
    ...t
  }, a = {};
  return Object.keys(n).forEach((c) => {
    const g = n[c];
    a[c.toLowerCase()] = g;
  }), a;
}
function Y(r) {
  try {
    return JSON.parse(r.content);
  } catch (e) {
    throw new C(e.message, r);
  }
}
function Z({ content: r, status: e }, t) {
  try {
    const n = JSON.parse(r);
    return "error" in n ? new B(n.message, e, n.error, t) : new x(n.message, e, t);
  } catch {
  }
  return new x(r, e, t);
}
function V({ isTimedOut: r, status: e }) {
  return !r && ~~e === 0;
}
function q({ isTimedOut: r, status: e }) {
  return r || V({ isTimedOut: r, status: e }) || ~~(e / 100) !== 2 && ~~(e / 100) !== 4;
}
function ee({ status: r }) {
  return ~~(r / 100) === 2;
}
function re(r) {
  return r.map((e) => L(e));
}
function L(r) {
  const e = r.request.headers["x-algolia-api-key"] ? { "x-algolia-api-key": "*****" } : {};
  return {
    ...r,
    request: {
      ...r.request,
      headers: {
        ...r.request.headers,
        ...e
      }
    }
  };
}
function ce({
  hosts: r,
  hostsCache: e,
  baseHeaders: t,
  logger: n,
  baseQueryParameters: a,
  algoliaAgent: c,
  timeouts: g,
  requester: l,
  requestsCache: u,
  responsesCache: f
}) {
  async function d(i) {
    const o = await Promise.all(
      i.map((s) => e.get(s, () => Promise.resolve(D(s))))
    ), S = o.filter((s) => s.isUp()), h = o.filter((s) => s.isTimedOut()), b = [...S, ...h];
    return {
      hosts: b.length > 0 ? b : i,
      getTimeout(s, y) {
        return (h.length === 0 && s === 0 ? 1 : h.length + 3 + s) * y;
      }
    };
  }
  async function v(i, o, S = !0) {
    const h = [], b = Q(i, o), p = X(t, i.headers, o.headers), s = i.method === "GET" ? {
      ...i.data,
      ...o.data
    } : {}, y = {
      ...a,
      ...i.queryParameters,
      ...s
    };
    if (c.value && (y["x-algolia-agent"] = c.value), o && o.queryParameters)
      for (const m of Object.keys(o.queryParameters))
        !o.queryParameters[m] || Object.prototype.toString.call(o.queryParameters[m]) === "[object Object]" ? y[m] = o.queryParameters[m] : y[m] = o.queryParameters[m].toString();
    let w = 0;
    const J = async (m, N) => {
      const A = m.pop();
      if (A === void 0)
        throw new G(re(h));
      const O = { ...g, ...o.timeouts }, k = {
        data: b,
        headers: p,
        method: i.method,
        url: F(A, i.path, y),
        connectTimeout: N(w, O.connect),
        responseTimeout: N(w, S ? O.read : O.write)
      }, z = (j) => {
        const I = {
          request: k,
          response: j,
          host: A,
          triesLeft: m.length
        };
        return h.push(I), I;
      }, P = await l.send(k);
      if (q(P)) {
        const j = z(P);
        return P.isTimedOut && w++, n.info("Retryable failure", L(j)), await e.set(A, D(A, P.isTimedOut ? "timed out" : "down")), J(m, N);
      }
      if (ee(P))
        return Y(P);
      throw z(P), Z(P, h);
    }, U = r.filter(
      (m) => m.accept === "readWrite" || (S ? m.accept === "read" : m.accept === "write")
    ), $ = await d(U);
    return J([...$.hosts].reverse(), $.getTimeout);
  }
  function T(i, o = {}) {
    const S = i.useReadTransporter || i.method === "GET";
    if (!S)
      return v(i, o, S);
    const h = () => v(i, o);
    if ((o.cacheable || i.cacheable) !== !0)
      return h();
    const p = {
      request: i,
      requestOptions: o,
      transporter: {
        queryParameters: a,
        headers: t
      }
    };
    return f.get(
      p,
      () => u.get(
        p,
        () => (
          /**
           * Finally, if there is no request in progress with the same key,
           * this `createRetryableRequest()` will actually trigger the
           * retryable request.
           */
          u.set(p, h()).then(
            (s) => Promise.all([u.delete(p), s]),
            (s) => Promise.all([u.delete(p), Promise.reject(s)])
          ).then(([s, y]) => y)
        )
      ),
      {
        /**
         * Of course, once we get this response back from the server, we
         * tell response cache to actually store the received response
         * to be used later.
         */
        miss: (s) => f.set(p, s)
      }
    );
  }
  return {
    hostsCache: e,
    requester: l,
    timeouts: g,
    logger: n,
    algoliaAgent: c,
    baseHeaders: t,
    baseQueryParameters: a,
    hosts: r,
    request: T,
    requestsCache: u,
    responsesCache: f
  };
}
export {
  _ as AlgoliaError,
  x as ApiError,
  C as DeserializationError,
  B as DetailedApiError,
  W as ErrorWithStackTrace,
  G as RetryError,
  M as createAlgoliaAgent,
  ae as createAuth,
  te as createBrowserLocalStorageCache,
  E as createFallbackableCache,
  ne as createMemoryCache,
  H as createNullCache,
  ie as createNullLogger,
  D as createStatefulHost,
  ce as createTransporter,
  Z as deserializeFailure,
  Y as deserializeSuccess,
  oe as getAlgoliaAgent,
  V as isNetworkError,
  q as isRetryable,
  ee as isSuccess,
  Q as serializeData,
  X as serializeHeaders,
  K as serializeQueryParameters,
  F as serializeUrl,
  se as shuffle,
  L as stackFrameWithoutCredentials,
  re as stackTraceWithoutCredentials
};
//# sourceMappingURL=help-center-articles-search49.js.map
